package ui.campaign

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.widget.*


@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CampaignListingScope.CampaignListingTooltip(
    item: CampaignListingScope.Wrapper.Item,
    itemMeasurer: ListingSpecs.Measurer,
    tooltipImageSize: Float,
    body: @Composable () -> Unit
) {

    Box {
        TooltipBox(
            positionProvider = TooltipDefaults.rememberPlainTooltipPositionProvider(),
            tooltip = {
                Box(
                    modifier = Modifier.fillMaxWidth()
                        .offset(x = itemMeasurer.contentBoundary?.left?.dp ?: 0.dp)
                ) {
                    Card {
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(8.dp),
                            modifier = Modifier.height(tooltipImageSize.dp)
                        ) {
                            if (item.data.isCommercial && item.data.isNonCommercial) {
                                Space(16.dp)
                                Column(Modifier.align(Alignment.CenterVertically)) {
                                    Text(Res.string.layer_top_listing__item_tooltip_commercial.rememberString())
                                    Text(Res.string.layer_top_listing__item_tooltip_non_commercial.rememberString())
                                }
                                Space(8.dp)
                                Column(Modifier.align(Alignment.CenterVertically)) {
                                    Text(item.counter.percentage.com)
                                    Text(item.counter.percentage.ncom)
                                }
                                Space(8.dp)
                                Column(Modifier.align(Alignment.CenterVertically)) {
                                    Text(item.counter.counter.com)
                                    Text(item.counter.counter.ncom)
                                }
                                Space(16.dp)
                            }
                            item.data.visuals
                                .take(6)
                                .forEach {
                                    LazyImage(
                                        id = it.id,
                                        modifier = Modifier
                                            .width(((it.width.toFloat() / it.height.toFloat()) * tooltipImageSize).dp)
                                            .height(tooltipImageSize.dp)
                                    )
                                }
                        }
                    }
                }

            },
            state = CustomTooltipState.rememberState(),
            focusable = false,
            enableUserInput = item.data.visuals.isNotEmpty(),
            content = body
        )
    }
}
